// extracted by mini-css-extract-plugin
export default {"wrapper":"ConditionBox_wrapper__1x1JV","condition":"ConditionBox_condition__9Tf8B"};